namespace('compass.show');

compass.show.ComingSoonWidget = compass.defineWidget(function ComingSoonWidget (options) {
	var me = this;
	var $j = jQuery;
	var d = $j.dom.getContext(me);

	var _settings = options;
	var _inputs = {};

	var _validator = new compass.validator({});

	var _handleSubmit = function (event) {
		me.trigger('ComingSoonWidget.EmailSubmitted', {
			email: _inputs.email.val()
		});
		event.preventDefault();
	};

	var _form;
	var _render = me.render = function (widgetElem) {
		_form = d.form({
			className: "reminderDetails",
			action: "javascript:;"
		},
			_drawEmailInput(),
			_drawSubmitButton()
		);

		widgetElem.append(
			_drawMessage(),
			_form,
			d.div({ className: "clear" })
		);
	};

	var _drawMessage = function () {
		return d.div({ className: "earlyMessage" }, 
			d.h6({ className: "earlyHeader" }, 
				_settings.welcome.header),
			d.p({ className: "earlyBody" }, 
				_settings.welcome.message
			)
		);
	};

	var _drawEmailInput = function () {
		_inputs.email = d.input({
			className: "email",
			name: "email",
			type: "text",
			placeholder: "Email address",
			autocomplete: 'off'
		});

		_inputs.email.bind('input', function () {
			var res = _validator.check(_validator.EMAIL, _inputs.email, { });
			if (res === _validator.VALID) {
				_submitButton.prop("disabled", false);
			} else {
				_submitButton.prop("disabled", true);
			}
		});

		return _inputs.email;
	};

	var _submitButton;
	var _drawSubmitButton = function () {
		_submitButton = d.button({
			className: "submit button"
		}, "Submit").activate(_handleSubmit);
		_submitButton.prop("disabled", true);

		return _submitButton;
	};

	var _tyShown = false;
	var _showThankYou = me.showSuccess = function () {
		if (_tyShown) { return; }

		var thanks = d.div({
			className: "tyMessage"
		}, d.h6({
				className: "tyHeader"
			}, _settings.thankYou.header),
			d.p({
				className: "tyBody"
			}, _settings.thankYou.message)
		);

		_tyShown = true;
		// animation
		_form.parent().contents().slideUp(function () { _form.remove(); });
		_form.before(thanks);
		thanks.hide().slideDown();
		// nonanimation
		// _form.before(thanks).remove();
	};
}, {
	WUID: 'defaultComingSoonWidgetWUID',
	widgetName: 'ComingSoonWidget',
	welcome: {
		header: "You're earlier than the early bird!",
		message: "Reservations can't be made for this show yet but " +
			"enter your email below and we'll contact you as soon as booking is open."
	},
	thankYou: {
		header: "Thank you!",
		message: "You will be contacted as soon as booking for the show opens"
	}
});

